import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Label,
  Icon,
  FileStatus,
  InputsPDFFormPure,
  ButtonHLPure,
} from "../../pures";
import { Grid } from "@material-ui/core";
import { TrashIcon } from "../../../assets/logos/icons";
import { PlusBlue } from "../../../assets/logos/icons";
import IneFrontTemplate from "../../../assets/logos/icons/frente_INEjpg.jpg";
import IneBackTemplate from "../../../assets/logos/icons/vuelta_reverso.jpg";
import "./reliable-signature-identification-documents.css";

const ReliableSignatueIdentificationDocumentsView = (props) => {
  const {
    step,
    onHandleBack,
    onHandleNext,
    onUploadFile,
    onDeleteFile,
    onImageChange,
    files,
    ineFrontImg, 
    ineBackImg,
  } = props;
  const { next, back } = step;
  const { t } = useTranslation();

  const inputFrontIne = useRef(null);
  const inputBackIne = useRef(null);
  const uploadFile = (ref) => ref.current.click();

  const onHandleSubmit = () => {
    const { ineFrontImg, ineBackImg, curpDocument, cfeDocument } = files;
    if (ineFrontImg && ineBackImg && curpDocument && cfeDocument)
    onHandleNext();
  };

  return (
    <div className="card-description-reliable">
      <Grid container>
        <div className="signatureBaseUploadINE-container-images">
          <div className="signatureBaseUploadINE-ine-front">
            <div className={"rec-signature-base"}  onClick={() => uploadFile(inputFrontIne)}>
              <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
              <img className={(ineFrontImg) ? "signatureBaseUploadINE-image-ine " :"signatureBaseUploadINE-image-default"} src={ineFrontImg ? ineFrontImg : IneFrontTemplate } />
            </div>
            <p className="signatureCredretialForm-p-sub">
              {t("signatureBaseUploadINE.ine.front")}
            </p>
          </div>
          <div className="signatureBaseUploadINE-ine-back">
            <div className={"rec-signature-base "} onClick={() => uploadFile(inputBackIne)} >
              <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
              <img className={(ineBackImg) ? "signatureBaseUploadINE-image-ine" : "signatureBaseUploadINE-image-default"} src={ineBackImg ? ineBackImg : IneBackTemplate} />
            </div>
            <p className="signatureCredretialForm-p-sub">
              {t("signatureBaseUploadINE.ine.back")}
            </p>
          </div>
        </div>
        <div className="ReliableSignatueIdentificationDocumentsView-identification-horizontal-center">
          <Grid item className="identification-margin-button">
            <Label
              title={t(
                "reliableSignatureIdentificationDocumentsView.curpDocument"
              )}
            />
          </Grid>
          <Grid
            className="identification-buttons-center"
            container
            direction="row"
            spacing={2}
            alignContent="center"
          >
            <Grid item>
              <InputsPDFFormPure
                onClick={(e) => (e.target.value = null)}
                onChange={(e) =>
                  onUploadFile(e, "curpDocument", [".pdf", ".PDF"])
                }
                messageBtn={t(
                  "reliableSignatureIdentificationDocumentsView.selectPDF"
                )}
                messageNotFile={t("signatureRequestView2.notuploadDocument")}
                colorBorderContainer={props.colorBorderContainer}
                selectedFile={files.curpDocument?.file}
              />
            </Grid>
            <Grid
              item
              className="ReliableSignatueIdentificationDocumentsView-icon-trash"
            >
              {files.curpDocument?.name ? (
                <img
                  src={TrashIcon}
                  alt="Elimina el documento"
                  onClick={() => onDeleteFile("curpDocument")}
                />
              ) : (
                ""
              )}
            </Grid>
            <Grid item>
              <FileStatus
                className="ReliableSignatueIdentificationDocumentsView-input-pdf-documents"
                content={
                  files.curpDocument?.name
                    ? files.curpDocument?.name
                    : t("reliableSignatureIdentificationDocumentsView.no.selectPDF")
                }
                active={files.curpDocument?.name}
              />
            </Grid>
          </Grid>
        </div>
        <div className="ReliableSignatueIdentificationDocumentsView-identification-horizontal-center">
          <Grid item className="identification-margin-button">
            <Label
              title={t(
                "reliableSignatureIdentificationDocumentsView.cfeDocument"
              )}
            />
          </Grid>
          <Grid
            className="identification-buttons-center"
            container
            direction="row"
            spacing={2}
            alignContent="center"
          >
            <Grid item>
              <InputsPDFFormPure
                onClick={(e) => (e.target.value = null)}
                onChange={(e) =>
                  onUploadFile(e, "cfeDocument", [".pdf", ".PDF"])
                }
                messageBtn={t(
                  "reliableSignatureIdentificationDocumentsView.selectPDF"
                )}
                messageNotFile={t("signatureRequestView2.notuploadDocument")}
                colorBorderContainer={props.colorBorderContainer}
                selectedFile={files.cfeDocument?.file}
              />
            </Grid>
            <Grid
              item
              className="ReliableSignatueIdentificationDocumentsView-icon-trash"
            >
              {files.cfeDocument?.name ? (
                <img
                  src={TrashIcon}
                  alt="Elimina el documento"
                  onClick={() => onDeleteFile("curpDocument")}
                />
              ) : (
                ""
              )}
            </Grid>
            <Grid item>
              <FileStatus
                className="ReliableSignatueIdentificationDocumentsView-input-pdf-documents"
                content={
                  files.cfeDocument?.name
                    ? files.cfeDocument?.name
                    : t("reliableSignatureIdentificationDocumentsView.no.selectPDF")
                }
                active={files.cfeDocument?.name}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
      <div className="ReliableSignatueIdentificationDocumentsView-action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>
      <input
        ref={inputFrontIne}
        onChange={(e) => onImageChange(e, "ineFrontImg")}
        type="file"
        id="fileKey"
        accept=".jpg, .jpeg, .png"
        style={{ display: "none" }}
      />
      <input
        ref={inputBackIne}
        onChange={(e) => onImageChange(e, "ineBackImg")}
        type="file"
        id="fileKey"
        accept=".jpg, .jpeg, .png"
        style={{ display: "none" }}
      />
    </div>
  );
};

export default ReliableSignatueIdentificationDocumentsView;
